import { render, staticRenderFns } from "./ProductDetailsModal.vue?vue&type=template&id=5687965a&scoped=true"
import script from "./ProductDetailsModal.vue?vue&type=script&lang=js"
export * from "./ProductDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsModal.vue?vue&type=style&index=0&id=5687965a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687965a",
  null
  
)

export default component.exports